<script lang="ts">
	import { goto, invalidateAll } from '$app/navigation';
	import { page } from '$app/stores';
	import SearchIcon from '$lib/assets/images/icons/search.svg?component';
	import __ from '$lib/stores/TranslationStore';
	import { onMount } from 'svelte';

	let value: string;
	let input: HTMLInputElement;
	let form: HTMLFormElement;

	onMount(() => {
		input.focus();
	});

	const searchQuery = () => {
		const query = new URLSearchParams();
		const data = new FormData(form);
		const q = data.get('q') as string | null;
		if (q) query.set('q', q);

		window.location.href =
			$page.data?.location?.origin + '/artigos/pesquisa' + '?' + query.toString();
	};
</script>

<section class="w-full bg-light py-3 md:py-6">
	<div class="container mx-auto">
		<form
			bind:this={form}
			on:submit|preventDefault={searchQuery}
			class="relative flex items-center text-dark"
		>
			{#if !value}
				<SearchIcon class="absolute left-0 ml-1 h-6 stroke-dark stroke-[2px] opacity-50 md:h-9" />
			{/if}
			<input
				bind:this={input}
				class="h-11 w-full whitespace-pre bg-inherit text-2xl outline-none placeholder:text-dark placeholder:opacity-50 md:text-4xl"
				type="text"
				name="q"
				bind:value
				placeholder="      {$__('Procurar um tema')}"
			/>
			<!-- <input type="hidden" name="gsc.tab" value={1} /> -->
		</form>
	</div>
</section>
